<script>
import TextInput from "../../../theme/atoms/BasicInput.vue";


export default {
  name: "ShareFormByLink",
  components: {TextInput},
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    formUrl() {
      return `${window.location.origin}/space/forms/${this.model.id}/view`
    }
  },
  data() {
    return {
      model: this.value,
    }
  },
  methods: {
    copyFormUrl() {
      navigator.clipboard.write([new ClipboardItem({"text/plain": new Blob([this.formUrl], {type: "text/plain"})})])
          .then(() => {
            this.$notify({type: 'success', text: trans('general.page.space_forms.messages.url_copied')});
          });
    },
  }
}
</script>

<template>
  <div >
    <div class="d-flex  mb-3 gap-2 ">
      <text-input :label="trans('general.page.space_forms.copy_form_url')" id="formUrl" ref="urlInput" class="flex-grow-1"
                  v-model="formUrl" :disabled="true"></text-input>
      <basic-button @click="copyFormUrl()" cls="btn btn-primary flex-grow-0 tour-copy-share-link" icon="icon fi fi-rr-copy" icon-position="right"
                    :text="trans('general.defaults.copy')" type="button"></basic-button>
    </div>
  </div>
</template>

<style scoped>

</style>
